import { FC, useState } from "react";
import { MDBCard, MDBCardTitle, MDBCardText } from "mdb-react-ui-kit";
import Image from "next/image";
import styles from "../../styles/detail/WhyPlayItalyCard.module.scss";

interface WhyPlayItalyCardData {
    id: string;
    image: string;
    title: string;
    description: string;
}

const WhyPlayItalyCard: FC<{ content: WhyPlayItalyCardData }> = ({
    content,
}) => {
    const [error, setError] = useState(false);

    return (
        <MDBCard className={styles.card}>
            <div className={styles.imageContainer}>
                <Image
                    src={
                        error
                            ? "/images/tours/across-italy-reduced.jpg"
                            : content.image
                    }
                    alt={content.title}
                    fill
                    className={styles.image}
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    quality={80}
                    onError={() => {
                        setError(true);
                    }}
                />
            </div>
            <div className={styles.overlay} />
            <div className={styles.cardContent}>
                <MDBCardTitle className={styles.cardTitle}>
                    {content.title}
                </MDBCardTitle>
                <MDBCardText className={styles.cardDescription}>
                    {content.description}
                </MDBCardText>
            </div>
        </MDBCard>
    );
};

export default WhyPlayItalyCard;
